import { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import {AppContext} from "./AppContext";

const ProtectedRoute = ({ children }) => {
    const { userId } = useContext(AppContext);
    return userId ? children : <Navigate to="/" />;
};

export default ProtectedRoute;
